import { api } from './api';

export interface WorkspaceDocumentDto {
  id: string;
  workspaceId: string;
  documentId: string;
  isActive: boolean;
  priority: number;
  updatedAt: string;
  workspaceName?: string;
  documentName?: string;
  documentPath?: string;
  /** Document.NodeType (ex.: folder) */
  documentNodeType?: string;
}

export interface CreateWorkspaceDocumentRequest {
  workspaceId: string;
  documentId: string;
  isActive?: boolean;
  priority?: number;
}

class WorkspaceDocumentService {
  async getByWorkspaceId(workspaceId: string): Promise<WorkspaceDocumentDto[]> {
    const response = await api.get<WorkspaceDocumentDto[]>(
      `/workspace-documents/by-workspace/${workspaceId}`
    );
    return Array.isArray(response.data) ? response.data : [];
  }

  async create(request: CreateWorkspaceDocumentRequest): Promise<WorkspaceDocumentDto> {
    const response = await api.post<WorkspaceDocumentDto>('/workspace-documents', {
      workspaceId: request.workspaceId,
      documentId: request.documentId,
      isActive: request.isActive ?? true,
      priority: request.priority ?? 0,
    });
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/workspace-documents/${id}`);
  }
}

export const workspaceDocumentService = new WorkspaceDocumentService();
